import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-tcm-chat-inquiry-answer-selected",
  "use": "icon-tcm-chat-inquiry-answer-selected-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-tcm-chat-inquiry-answer-selected\">\r\n  <defs>\r\n    <style>#icon-tcm-chat-inquiry-answer-selected .a{fill:#0062ff;}#icon-tcm-chat-inquiry-answer-selected .b{fill:#fff;}</style>\r\n  </defs>\r\n  <path class=\"a\" d=\"M8,8,0,8A8,8,0,1,0,8,0,8,8,0,0,0,0,8Z\" transform=\"translate(0 0)\" />\r\n  <path class=\"b\" d=\"M150.79,278.126l4.942-4.859a1.209,1.209,0,0,1,1.642-.03,1.057,1.057,0,0,1,.031,1.554l-5.739,5.642a1.209,1.209,0,0,1-1.634.038l-3.382-3.016a1.057,1.057,0,0,1-.048-1.553,1.209,1.209,0,0,1,1.642-.046Z\" transform=\"translate(-144.088 -268.495)\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/tcm-chat-inquiry-answer-selected.svg
// module id = QerD
// module chunks = 10